const devildom = `

#### Devildom Entry
To access the new dungeon, you must be **level 175** and complete the new questline, starting at **Friendly Mardukan Nakibu**.

![Devildom Entry](assets/guide/devildom_quest_us.png)

#### Yushiva's Belt
To craft **Yushiva's Belt**, you need the following materials:

![Yushiva's Belt](assets/guide/yushivabelt_us.png)

#### Blacksmith Tarun, in Katan
You can craft **Devildom equipment** at **Blacksmith Tarun** in Katan.

![Blacksmith Tarun](assets/guide/devildomrustung_us.png)

#### Full Equipment Overview

![Devildom Equipment](assets/guide/devildom_equip_us.png)`;

export default devildom;
